import { Button, Grid, Card } from '@cxc/react-fpds-components';
import styles from './Summary.module.scss';
import Modal from '../Modal/Modal';
import { PopUp } from '@cxc/react-fpds-icons-v1';
import { useState } from 'react';
import {
    ButtonPlacementType,
    SUMMARY_PAGE_MODAL_DATA,
    NO_END_DATE,
} from '../../constants/SummaryConstants';
import SummaryProps from '../../types/props/SummaryProps';
import dayjs from 'dayjs';
import { formatCapitalizeFirstLetters, getColorBasedOnStatus } from '../../utils/utils';

const Summary = ({ incentive }: SummaryProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const rowGap = 20;

    const getUserFriendlyDeadline = (): string => {
        if (incentive?.userFriendlyDeadline === null || incentive?.userFriendlyDeadline === '') {
            return NO_END_DATE;
        } else {
            return incentive.userFriendlyDeadline;
        }
    };

    const getHexaColorBasedOnDeadline = (userFriendlyDeadline: string): string => {
        let color = '';
        if (userFriendlyDeadline !== NO_END_DATE) {
            color = '#D62D0A';
        }
        return color;
    };

    const getFormattedDate = (expirationDateInString: string) => {
        let formattedDate = '';
        if (expirationDateInString !== null && expirationDateInString !== '') {
            const expirationDate = dayjs(expirationDateInString);
            formattedDate = expirationDate.format('MMM D, YYYY');
        }
        return formattedDate;
    };

    const getValue = (incentive: number) => {
        return incentive.toLocaleString();
    };

    return (
        <>
            <Grid rowGap={rowGap} style={{ marginTop: '2rem' }}>
                <Grid.Item xl={8} l={8} m={12} s={12}>
                    <Grid rowGap={rowGap}>
                        <Grid.Item xl={12} l={12} m={6} s={6}>
                            <Card
                                className={styles.cardTagStyles}
                                titleProp={{
                                    title: incentive.potentialValue,
                                    headingLevel: 'h6',
                                }}
                            >
                                <Card.Tag title="Potential Value" />
                            </Card>
                        </Grid.Item>
                        <Grid.Item xl={6} l={6} m={6} s={6}>
                            <Card
                                className={styles.cardTagStyles}
                                titleProp={{
                                    title: (
                                        <span
                                            style={{
                                                color: `${getColorBasedOnStatus(
                                                    incentive.currentProgramStatus,
                                                )}`,
                                            }}
                                        >
                                            {formatCapitalizeFirstLetters(
                                                incentive.currentProgramStatus,
                                            )}
                                        </span>
                                    ),
                                    headingLevel: 'h1',
                                    size: 'large',
                                }}
                            >
                                <Card.Tag title="Status" />
                                <Card.Footer>
                                    <Card.SubTitle headingLevel="h2">
                                        ${getValue(incentive.fundingCapPerApplicant)}
                                    </Card.SubTitle>
                                </Card.Footer>
                            </Card>
                        </Grid.Item>
                        <Grid.Item xl={6} l={6} m={6} s={6}>
                            <Card
                                className={styles.cardTagStyles}
                                titleProp={{
                                    title: (
                                        <span style={{ color: '#00142E' }}>
                                            {formatCapitalizeFirstLetters(incentive.grantorType)}
                                        </span>
                                    ),
                                    headingLevel: 'h1',
                                    size: 'large',
                                }}
                            >
                                <Card.Tag title="Grantor" />
                                <Card.Footer>
                                    <Card.SubTitle headingLevel="h2">
                                        {incentive.grantorName}
                                    </Card.SubTitle>
                                </Card.Footer>
                            </Card>
                        </Grid.Item>
                    </Grid>
                </Grid.Item>
                <Grid.Item xl={4} l={4} m={12} s={12}>
                    <Card
                        className={styles.cardTagStyles}
                        titleProp={{
                            title: (
                                <span
                                    style={{
                                        color: `${getHexaColorBasedOnDeadline(
                                            getUserFriendlyDeadline(),
                                        )}`,
                                    }}
                                >
                                    {getUserFriendlyDeadline()}
                                </span>
                            ),
                            headingLevel: 'h1',
                            size: 'large',
                        }}
                    >
                        <Card.Tag title="Deadline" />
                        <Card.SubTitle headingLevel="h2">
                            {getFormattedDate(incentive.expirationDate)}
                        </Card.SubTitle>

                        <Card.Footer>
                            <Button style={{ gap: '16px' }} onClick={() => setIsOpen(true)}>
                                Visit Grantor Site <PopUp size={'s'} />
                            </Button>
                            <Modal
                                title={SUMMARY_PAGE_MODAL_DATA.TITLE}
                                buttons={SUMMARY_PAGE_MODAL_DATA.BUTTONS}
                                buttonPlacement={ButtonPlacementType.right}
                                description={SUMMARY_PAGE_MODAL_DATA.DESCRIPTION}
                                isOpen={isOpen}
                                setIsOpen={setIsOpen}
                                headingLevel={'h1'}
                                variant={'large'}
                                url={incentive.incentiveUrl}
                            />
                        </Card.Footer>
                    </Card>
                </Grid.Item>
            </Grid>
        </>
    );
};

export default Summary;
